enum ActionTypes {
    RequestEmojis = "emojis/request",
    AddEmojis = "emojis/add",
    EmojisError = "emojis/error"
}

export default ActionTypes;
